<template>
  <div class="body-width divcss5 div-bottom2">
    <div class="div-img-top1 div-m body-width">
      <div class="font_zh">{{$t("news.newsinfomation")}}</div>
      <div class="font_en font_en_top">NEWS INFORMATION</div>
    </div>
    <div class="news-Medium-18-2e79be div-left">新闻列表</div>
    <div class="tr-top">
      <el-table
        ref="multipleTable"
        element-loading-text="拼命加载中"
        size="mini"
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%;"
        @sort-change="handleSortChange"
      >
        <el-table-column label="序号" width="100" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>

        <el-table-column label="新闻列表" width="900" align="left">
          <template slot-scope="scope">
            <a href="javascript:void(0);" @click="setroters(scope.row)">{{ scope.row.newsTitle}}</a>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.releaseTime) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          v-show="this.tableData.length > 0"
          :current-page.sync="listNews.pageNum"
          :page-sizes="[10,20,50,100]"
          :page-size="listNews.pageSize"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    
  </div>
</template>
  
  <script>
import { getAllNews } from "@/api/news/newsInfo.js";
import { formatDate } from "@/utils/date";

export default {
  data() {
    return {
      listNews: {
        id:'',
        newsTitle: "",
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      total: 0,
    };
  },
  methods: {
    fetchNews() {
      getAllNews(this.listNews).then(res => {
        console.log(res);
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    formatDate(time) {
        let date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },
      handleSearch() {
      this.fetchNews();
    },
      handleResetSearch() {
      this.listNews.newsTitle = "";
      this.listNews.pageNum = 1;
      this.handleSearch();
    },
      handleSizeChange(size) {
      this.listNews.pageSize = size;
      this.handleSearch();
    },
    handleCurrentChange(page) {
      this.listNews.pageNum = page;
      this.handleSearch();
    },
    sortCreateTime(a, b) {
      return new Date(a.createTime) - new Date(b.createTime);
    },
    // 在表格组件上监听 sort-change 事件
    handleSortChange({ column, prop, order }) {
      if (prop === "createTime") {
        this.tableData.sort(this.sortCreateTime);
        if (order === "descending") {
          this.tableData.reverse();
        }
      }
    },
     
    setroters(row) {
      console.log(1111)
      console.log(row)
        this.$router.push({
          path: 'newscontent',
          query: {
            row: row
          }
        })

      },
  },
  created() {
    this.fetchNews();
  }
};
</script>
  
  <style scoped>
.tr-top {
  cursor: pointer;
  border-top: 1px #e2e2e2 dashed;
  margin-top: 20px;
  padding-top: 30px;
  padding-bottom: 60px;
  border-bottom: 1px #e2e2e2 solid;
}

.div-left {
  text-align: left;
  padding-left: 20px;
}

.div-float-left {
  float: left;
  text-align: left;
  padding-left: 20px;
}

.div-float-right {
  float: right;
  text-align: right;
  padding-right: 20px;
}

.news-Regular-14-2e79be {
  font-family: "SourceHanSansCN-Regular";
  font-size: 14px;
  color: #2e79be;
}

.div-bottom2 {
  /* margin-bottom: 190px; */
}
.pagination-container {
  text-align: left;
  margin-top: 20px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/contentcoms/newscontentcoms/newstable.vue